module.exports = __webpack_public_path__ + "img/droplet.b7391b77.svg";